import {
  Directive,
  ElementRef,
  Renderer2,
  SimpleChanges,
  Input,
  OnInit,
  OnChanges,
  Optional,
  Self,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { shareReplay } from 'rxjs/operators';

import { Observable } from 'rxjs';

import { ICommonValue } from '../models/common-value-model';

@Directive()
export abstract class BaseSelectInputDirective implements OnInit, OnChanges {
  //  tslint:disable-next-line:no-input-rename
  @Input('renci-error-text') errorText = 'Error occurred';
  //  tslint:disable-next-line:no-input-rename
  @Input('renci-load-text') loadText = 'Loading...';
  //  tslint:disable-next-line:no-input-rename
  @Input('renci-hidden-text') hiddenText = '*** hidden ***';

  private element: HTMLSelectElement;
  private options = [];
  private loadingOption: HTMLOptionElement;
  private errorOption: HTMLOptionElement;
  private handleOnChanges = false;

  constructor(
    @Optional() @Self() private formControl: NgControl,
    elem: ElementRef,
    private renderer: Renderer2
  ) {
    this.element = elem.nativeElement;

    this.loadingOption = this.renderer.createElement('option');
    this.errorOption = this.renderer.createElement('option');
  }

  ngOnInit(): void {
    setTimeout(() => this.setItems(), 0);
    this.handleOnChanges = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.handleOnChanges && this.refreshNeeded(changes)) {
      setTimeout(() => this.setItems(), 0);
    }
  }

  setItems() {
    const value = this.formControl.value ?? '';

    this.renderer.removeChild(this.element, this.errorOption);
    for (const option of this.options) {
      this.renderer.removeChild(this.element, option);
    }
    this.options.length = 0;

    this.loadingOption.value = value;
    this.loadingOption.selected = true;
    this.renderer.insertBefore(
      this.element,
      this.loadingOption,
      this.element.firstChild
    );

    this.element.disabled = true;

    this.getData(value)
      .pipe(shareReplay())
      .subscribe(
        (optionValues: Array<any>) => {
          this.options = optionValues.map((optionValue) => {
            const option = this.renderer.createElement('option');
            const text = this.renderer.createText(optionValue.text);
            option.value = optionValue.id;
            option.selected = optionValue.id === value;
            this.renderer.appendChild(option, text);
            return option;
          });

          //  If loaded options don't include selected value add it as hidden
          if (
            value &&
            !this.options.find((m) => m.value === value.toString())
          ) {
            const option = this.renderer.createElement('option');
            const text = this.renderer.createText(this.hiddenText);
            option.value = value;
            option.selected = true;
            this.renderer.appendChild(option, text);
            this.options.push(option);
          }

          for (const option of this.options) {
            this.renderer.appendChild(this.element, option);
          }

          this.element.disabled = this.formControl.disabled;

          this.renderer.removeChild(this.element, this.loadingOption);
        },
        (error) => {
          console.error(error);

          this.errorOption.text = this.errorText;
          this.errorOption.value = value;
          this.errorOption.selected = true;
          this.renderer.insertBefore(
            this.element,
            this.errorOption,
            this.element.firstChild
          );

          this.renderer.removeChild(this.element, this.loadingOption);
        }
      );
  }

  refreshNeeded: (SimpleChanges) => boolean = (_) => true;

  abstract getData(value: any): Observable<ICommonValue[]>;
}
